import { render } from "./PlayOptionView.vue?vue&type=template&id=9c57a79a&ts=true"
import script from "./PlayOptionView.vue?vue&type=script&lang=ts"
export * from "./PlayOptionView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Plays/Options/PlayOptionView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c57a79a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c57a79a', __exports__)) {
    api.reload('9c57a79a', __exports__)
  }
  
  module.hot.accept("./PlayOptionView.vue?vue&type=template&id=9c57a79a&ts=true", () => {
    api.rerender('9c57a79a', render)
  })

}


export default __exports__